<template>
  <div v-if="hasNode" :style="alignStyle">
    <VNode :node="node" :item="item"/>
  </div>
  <span v-else :style="alignStyle">
    <TreeGridExpandButton
      v-if="columnIndex === 0"
      :deep="deep"
      :expanded="expanded"
      :item="item"
      :hasItems="hasItems"
      @expand="$emit('expand', $event)"
      @close="$emit('close', $event)"
    />
    {{ hasValue ? this.localValue : '-' }}
  </span>
</template>

<script>
import { useReactiveModelMixin } from './mixins'

import TreeGridExpandButton from './TreeGridExpandButton.vue'

const reactiveValueMixin = useReactiveModelMixin(
  'value',
  {
    type: [String, Number],
    default: '',
    required: false
  })

export default {
  name: 'TreeGridRow',
  mixins: [
    reactiveValueMixin
  ],
  components: {
    TreeGridExpandButton,
    VNode: {
      functional: true,
      render: (_, ctx) => {
        for (let i in ctx.props.node) {
          ctx.props.node[i].componentOptions.propsData.item = ctx.props.item
        }

        return ctx.props.node
      }
    }
  },
  props: {
    align: {
      type: String,
      default: 'center'
    },
    node: {
      type: [Array, Node, null],
      default: null,
      required: false
    },
    item: {
      type: Object,
      default: null,
      required: false
    },
    deep: {
      type: Number,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    },
    hasItems: {
      type: Boolean,
      required: true
    },
    rowIndex: {
      type: Number,
      required: true
    },
    columnIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    hasValue () {
      return this.localValue !== null && this.localValue !== undefined && this.localValue !== ''
    },
    hasNode () {
      return this.node !== null && this.node !== undefined
    },
    alignStyle () {
      let align = this.align ? this.align : 'center'
      if (this.columnIndex === 0) align = 'left'

      return `text-align: ${align}; display: flex; justify-content: ${align}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treegrid/TreeGridRow.vue